<!--begin::Loading-->
<div *ngIf="isLoading" class="d-flex align-items-center justify-content-center py-20">
	<div class="spinner-border text-primary me-3" role="status">
		<span class="visually-hidden">Loading...</span>
	</div>
	Loading client details...
</div>
<!--end::Loading-->

<div *ngIf="!isLoading && user" class="d-flex flex-column flex-lg-row">

	<!--begin::Sidebar-->
	<div class="flex-column flex-lg-row-auto w-lg-250px w-xl-350px mb-10">
		<!--begin::Card-->
		<div class="card mb-5 mb-xl-8">
			<div class="card-body">
				<!--begin::User Info-->
				<div class="d-flex flex-center flex-column py-5">
					<!--begin::Avatar-->
					<div class="symbol symbol-100px symbol-circle mb-7">
						<img *ngIf="getAvatarDisplay().type === 'image'" [src]="getAvatarDisplay().value" alt="avatar" />
						<span *ngIf="getAvatarDisplay().type === 'initial'" class="symbol-label fs-1 fw-bold"
							[ngClass]="getAvatarDisplay().bgClass">{{ getAvatarDisplay().value }}</span>
					</div>
					<!--end::Avatar-->
					<!--begin::Name-->
					<span class="fs-3 text-gray-800 fw-bold mb-3">{{ user.title }} {{ user.name }}</span>
					<!--end::Name-->
					<!--begin::Badges-->
					<div class="mb-4 d-flex flex-wrap justify-content-center gap-2">
						<div class="badge badge-lg d-inline"
							[ngClass]="user.status === 'permitted' ? 'badge-light-success' : 'badge-light-danger'">
							{{ user.status | titlecase }}
						</div>
						<div *ngIf="user.rating" class="badge badge-lg d-inline" [ngClass]="getRatingBadgeClass()">
							{{ user.rating | titlecase }}
						</div>
					</div>
					<!--end::Badges-->
					<!--begin::Actions-->
					<div class="d-flex flex-wrap justify-content-center gap-2">
						<button type="button" class="btn btn-sm btn-outline btn-outline-primary" (click)="loginAsClient()"
							[disabled]="loginAsClientLoading">
							<span *ngIf="loginAsClientLoading" class="spinner-border spinner-border-sm me-1" role="status">
								<span class="visually-hidden">Loading...</span>
							</span>
							Login As Client
						</button>
						<button type="button" class="btn btn-sm btn-outline btn-outline-primary"
							(click)="openBidHistory()">
							Bid History
						</button>
					</div>
					<!--end::Actions-->
				</div>
				<!--end::User Info-->
				<div class="separator"></div>
				<!--begin::Details content-->
				<div class="pb-5 fs-6">
					<!--begin::Details item-->
					<div class="fw-bold mt-5">Account ID</div>
					<div class="text-gray-600">{{ user._id || user.doc_id || 'N/A' }}</div>
					<!--end::Details item-->
					<!--begin::Details item-->
					<div class="fw-bold mt-5">Email</div>
					<div class="text-gray-600">
						<a [href]="'mailto:' + user.email" class="text-gray-600 text-hover-primary">{{ user.email || 'N/A' }}</a>
					</div>
					<!--end::Details item-->
					<!--begin::Details item-->
					<div class="fw-bold mt-5">Phone</div>
					<div class="text-gray-600">{{ user.phone || 'N/A' }}</div>
					<!--end::Details item-->
					<!--begin::Details item-->
					<div class="fw-bold mt-5">Mobile</div>
					<div class="text-gray-600">{{ user.mobile || 'N/A' }}</div>
					<!--end::Details item-->
					<!--begin::Details item-->
					<div class="fw-bold mt-5">Fax</div>
					<div class="text-gray-600">{{ user.fax || 'N/A' }}</div>
					<!--end::Details item-->
					<!--begin::Details item-->
					<div class="fw-bold mt-5">Skype ID</div>
					<div class="text-gray-600">{{ user.skype_id || 'N/A' }}</div>
					<!--end::Details item-->
					<!--begin::Details item-->
					<div class="fw-bold mt-5">Address</div>
					<div class="text-gray-600">
						{{ user.address || 'N/A' }}
						<br *ngIf="user.city || user.state" />{{ user.city }}<span *ngIf="user.city && user.state">, </span>{{ user.state }}
						<br *ngIf="user.country" />{{ user.country }}
					</div>
					<!--end::Details item-->
					<!--begin::Details item-->
					<div class="fw-bold mt-5">Port</div>
					<div class="text-gray-600">{{ user.port_obj?.name || 'N/A' }}</div>
					<!--end::Details item-->
					<!--begin::Details item-->
					<div class="fw-bold mt-5">Last Login</div>
					<div class="text-gray-600">{{ user.last_login ? (user.last_login | date:'dd MMM yyyy, h:mm a') : 'Never' }}</div>
					<!--end::Details item-->
				</div>
				<!--end::Details content-->
			</div>
		</div>
		<!--end::Card-->
	</div>
	<!--end::Sidebar-->

	<!--begin::Content-->
	<div class="flex-lg-row-fluid ms-lg-15">

		<!--begin::Company & Account Card-->
		<div class="card card-flush mb-6 mb-xl-9">
			<div class="card-header mt-6">
				<div class="card-title flex-column">
					<h2 class="mb-1">Company & Account</h2>
					<div class="fs-6 fw-semibold text-muted">Registration and billing information</div>
				</div>
			</div>
			<div class="card-body pt-0">
				<div class="row">
					<div class="col-md-4 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Company</div>
						<div class="fs-6 text-gray-800">{{ user.company || 'N/A' }}</div>
					</div>
					<div class="col-md-4 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Sales Person</div>
						<div class="fs-6 text-gray-800">{{ user.sales_person || 'N/A' }}</div>
					</div>
					<div class="col-md-4 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Registered On</div>
						<div class="fs-6 text-gray-800">{{ user.created_at ? (user.created_at | date:'dd MMMM, yyyy') : 'N/A' }}</div>
					</div>
					<div class="col-md-4 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Currency</div>
						<div class="fs-6 text-gray-800">{{ (user.currency_type | uppercase) || 'USD' }}</div>
					</div>
					<div class="col-md-4 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Opening Balance</div>
						<div class="fs-6 text-gray-800">
							{{ user.opening_balance || 0 | number:'1.2-2' }}
							<span class="text-muted fs-7" *ngIf="user.opening_balance_type">({{ user.opening_balance_type | titlecase }})</span>
						</div>
					</div>
					<div class="col-md-4 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Email Verified</div>
						<div class="fs-6">
							<span class="badge" [ngClass]="user.is_verified ? 'badge-light-success' : 'badge-light-danger'">
								{{ user.is_verified ? 'Verified' : 'Not Verified' }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--end::Company & Account Card-->

		<!--begin::Permissions Card-->
		<div class="card card-flush mb-6 mb-xl-9">
			<div class="card-header mt-6">
				<div class="card-title flex-column">
					<h2 class="mb-1">Permissions</h2>
					<div class="fs-6 fw-semibold text-muted">Access and feature permissions for this client</div>
				</div>
			</div>
			<div class="card-body pt-0">
				<div class="row">
					<div class="col-md-3 col-sm-6 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Broker</div>
						<span class="badge" [ngClass]="user.permissions?.broker ? 'badge-light-success' : 'badge-light-danger'">
							{{ user.permissions?.broker ? 'Yes' : 'No' }}
						</span>
					</div>
					<div class="col-md-3 col-sm-6 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Auction</div>
						<span class="badge" [ngClass]="user.permissions?.auction ? 'badge-light-success' : 'badge-light-danger'">
							{{ user.permissions?.auction ? 'Yes' : 'No' }}
						</span>
					</div>
					<div class="col-md-3 col-sm-6 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">USS</div>
						<span class="badge" [ngClass]="user.permissions?.uss ? 'badge-light-success' : 'badge-light-danger'">
							{{ user.permissions?.uss ? 'Yes' : 'No' }}
						</span>
					</div>
					<div class="col-md-3 col-sm-6 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">USS Image</div>
						<div class="fs-6 text-gray-800">{{ user.permissions?.uss_image || 0 }}</div>
					</div>
					<div class="col-md-3 col-sm-6 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Bids</div>
						<span class="badge" [ngClass]="user.permissions?.bids ? 'badge-light-success' : 'badge-light-danger'">
							{{ user.permissions?.bids ? 'Yes' : 'No' }}
						</span>
					</div>
					<div class="col-md-3 col-sm-6 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Bid Permission</div>
						<span class="badge" [ngClass]="user.permissions?.bid_permission === 'yes' ? 'badge-light-success' : 'badge-light-danger'">
							{{ (user.permissions?.bid_permission | titlecase) || 'No' }}
						</span>
					</div>
					<div class="col-md-3 col-sm-6 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Sales Stats.</div>
						<span class="badge" [ngClass]="user.permissions?.sales_stats ? 'badge-light-success' : 'badge-light-danger'">
							{{ user.permissions?.sales_stats ? 'Yes' : 'No' }}
						</span>
					</div>
					<div class="col-md-3 col-sm-6 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Show CIF</div>
						<span class="badge" [ngClass]="user.permissions?.show_cif ? 'badge-light-success' : 'badge-light-danger'">
							{{ user.permissions?.show_cif ? 'Yes' : 'No' }}
						</span>
					</div>
					<div class="col-md-3 col-sm-6 mb-6">
						<div class="fw-bold text-muted fs-7 text-uppercase mb-1">Show Resale Price</div>
						<span class="badge" [ngClass]="user.permissions?.show_resale_price ? 'badge-light-success' : 'badge-light-danger'">
							{{ user.permissions?.show_resale_price ? 'Yes' : 'No' }}
						</span>
					</div>
				</div>
			</div>
		</div>
		<!--end::Permissions Card-->

	</div>
	<!--end::Content-->
</div>

<!--begin::Not found-->
<div *ngIf="!isLoading && !user" class="text-center py-20">
	<div class="text-muted fs-4">Client not found.</div>
</div>
<!--end::Not found-->
